import { RegistryItem } from "@schemas/agreements/schema";
import RentAgreementForm from "view/agreements/components/form/RentAgreementForm";
import RentAgreementDetails from "view/agreements/components/details/RentAgreementDetails";
import { AgreementTypeEnum, CalculationMethodType, DeclarationMonthTerm, TimeUnit } from "__generated__/graphql";
import ezStore from "ezStore";
import { hasPluginPermission } from "utils";
import type { RowValidationContext } from "view/agreements/validation/requiredUtils";

const automaticRentDeclarationsEnabled = () =>
	hasPluginPermission(ezStore.getState().session, "automaticRentDeclarations");

const isManual = (context: RowValidationContext) =>
	context.calculationMethodType === CalculationMethodType.Manual;

export const RentSchema: RegistryItem = {
	[AgreementTypeEnum.Rent]: {
		Form: RentAgreementForm,
		Details: RentAgreementDetails,
		defaultValues: {
			availableHoursADay: 16,
			workdays: 1,
			declarationMonthTerm: DeclarationMonthTerm.Month,
			calculationMethod: {
				type: CalculationMethodType.TimeUnit,
				timeUnit: TimeUnit.Day,
			},
		},
		agreementFields: {
			"agreement.availableHoursADay": {
				path: "availableHoursADay",
				rules: {
					hiddenIf: isManual,
					requiredIf: (context) => !isManual(context),
				},
			},
			"agreement.workdays": {
				path: "workdays",
				rules: {
					hiddenIf: isManual,
					requiredIf: (context) => !isManual(context),
				},
			},
			"agreement.declarationMonthTerm": {
				path: "declarationMonthTerm",
				rules: {
					hiddenIf: (context) => isManual(context) || !automaticRentDeclarationsEnabled(),
					requiredIf: (context) => !isManual(context) && automaticRentDeclarationsEnabled(),
				},
			},
			"agreement.manualActionRequired": { rules: { hidden: true } },
			"agreement.conditions": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.minimumTimeUnitsPayable": { rules: { hidden: true } },
		},
		toInput: (form) => ({
			availableMonday: true,
			availableTuesday: true,
			availableWednesday: true,
			availableThursday: true,
			availableFriday: true,
			availableSaturday: form.workdays === 2 || form.workdays === 3,
			availableSunday: form.workdays === 3,
			availableHoursADay: form.availableHoursADay,
			declarationMonthTerm: form.declarationMonthTerm,
		}),
		toForm: (agreement) => {
			return ({
				availableHoursADay: agreement.shipAvailability?.availableHoursADay ?? undefined,
				workdays: agreement.workdays ?? undefined,
				declarationMonthTerm: agreement.declarationMonthTerm ?? undefined,
			});
		},
	},
};
